import { useExperimentVariant } from 'src/utils/experimentNew'
import { Experiments } from '../constants'

type Variant = 'control' | 'treatment'

const EXPERIMENT_KEY = Experiments.SearchBarAutocomplete

export function useSearchBarAutocompleteExperiment() {
  const { value: variant } = useExperimentVariant<Variant>(
    EXPERIMENT_KEY,
    'control',
  )

  return {
    variant,
    enableAutocomplete: variant === 'treatment',
  }
}
